import { logger } from "../Logger"
import store from "../../store"

const defaultOptions = {
    seconds: 5,
    persistent: false
}

export const notify = {
    notify: (message, seconds, persistent) => {
        logger.log(message);

        seconds = seconds || defaultOptions.seconds;
        persistent = persistent || defaultOptions.persistent;
        store.dispatch("notify/pushNotification", {
            seconds,
            persistent,
            message
        });
    },
    notifyError: (error, seconds, persistent) => {
        logger.log(error.message);

        seconds = seconds || defaultOptions.seconds;
        persistent = persistent || defaultOptions.persistent;
        store.dispatch("notify/pushNotification", {
            seconds,
            persistent,
            message: error.message
        });
    }
};

export default {
    install(Vue) {
        Vue.prototype.$notify = notify.notify;
        Vue.prototype.$notifyError = notify.notifyError;
    }
}